import React, { Component } from 'react';
import { connect } from 'react-redux';
import EditDealershipSettings from '../../inputs/EditDealershipSettings';
import EditInstallation from '../../inputs/EditInstallation';
import EditFeedProvider from '../../inputs/EditFeedProvider';
import DropBoxFeed from '../../inputs/FileUploadButton/DropBoxFeed';
import { updateFeedProviders, startFeedScan } from '../../actions/apiFeedCenter';
import { getFeedScanSummary } from '../../actions/apiGetInfo';
import { readableStampWithZone } from '../../utils/dateFunctions';
import S3_PROVIDER_PRESETS from './s3ProviderPresets';
import './feedSettings.scss';

const S3_INGEST_BUCKET = 's3://ingest.autoipacket.com/';

class FeedSettings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value1: this.props.override_value_1,
			current_default_profile: this.props.current_default_profile,
			errors: { addDepartmentPropertyError: false },
			option_name: '',
			s3Preset: '',
			s3Draft: null,
			s3PresetSaving: false,
			s3ScanRunning: false,
			s3ScanError: '',
		};
		this.onS3PresetChange = this.onS3PresetChange.bind(this);
		this.onS3DraftChange = this.onS3DraftChange.bind(this);
		this.applyS3Preset = this.applyS3Preset.bind(this);
		this.cancelS3Preset = this.cancelS3Preset.bind(this);
		this.runS3Sync = this.runS3Sync.bind(this);
	}

	componentDidMount() {
		this.props.getFeedScanSummary();
	}

	dealerSettingValue(name) {
		const self = this;
		const settings = self.props.dealer_settings;
		let value = _.sortBy(_.filter(settings, o => o.key === name && o.dealership === self.props.installation.subdomain), 'id');
		if (value.length === 0) {
			value = _.sortBy(_.filter(settings, o => o.key === name && (o.dealership === '' || o.dealership === null || o.dealership === undefined)), 'id');
		}
		if (value.length > 0) {
			if (typeof value[0] !== 'undefined' && typeof value[0].value !== 'undefined') {
				return value[0].value;
			}
		}
		return '';
	}

	currentFeedProvider() {
		const { installation, feed_providers } = this.props;
		if (!installation || !installation.provider || !Array.isArray(feed_providers)) {
			return null;
		}
		return feed_providers.find(provider => provider.name === installation.provider) || null;
	}

	isS3Configured(feedProvider) {
		if (!feedProvider) return false;
		return ['s3_prefix', 'importer_class', 'feed_path_env'].every((field) => {
			const value = feedProvider[field];
			return value != null && String(value).trim() !== '';
		});
	}

	runS3Sync() {
		if (this.state.s3ScanRunning) return;
		this.setState({ s3ScanRunning: true, s3ScanError: '' });
		this.props.startFeedScan('startFeedScan')
			.catch(() => this.setState({
				s3ScanError: 'S3 sync failed to start. Try again.',
			}))
			.finally(() => this.setState({ s3ScanRunning: false }));
	}

	feedScanSummary() {
		const { scanned_at: scannedAt, message } = this.props.feed_scan_summary || {};
		const details = [scannedAt && readableStampWithZone(scannedAt), message].filter(Boolean);

		return `Last S3 scan: ${details.length ? details.join(' — ') : 'Never scanned'}`;
	}

	onS3PresetChange(e) {
		const s3Preset = e.target.value;
		this.setState({
			s3Preset,
			s3Draft: s3Preset ? { ...S3_PROVIDER_PRESETS[s3Preset] } : null,
		});
	}

	onS3DraftChange(name, value) {
		this.setState((prevState) => {
			if (!prevState.s3Preset) return null;
			return {
				s3Draft: {
					...prevState.s3Draft,
					[name]: value,
				},
			};
		});
	}

	applyS3Preset() {
		const feedProvider = this.currentFeedProvider();
		const { s3Draft } = this.state;
		if (!feedProvider || !s3Draft) {
			return;
		}

		const data = {
			id: feedProvider.id,
			s3_prefix: s3Draft.s3_prefix,
			importer_class: s3Draft.importer_class,
			feed_path_env: s3Draft.feed_path_env,
		};

		this.setState({ s3PresetSaving: true });
		this.props.updateFeedProviders(feedProvider.id, data, 'applyS3ProviderPreset')
			.then(() => this.setState({
				s3Preset: '',
				s3Draft: null,
				s3PresetSaving: false,
			}))
			.catch(() => this.setState({ s3PresetSaving: false }));
	}

	cancelS3Preset() {
		this.setState({
			s3Preset: '',
			s3Draft: null,
		});
	}

	s3KeyPreview(feedProvider) {
		const { installation } = this.props;
		const missing = [];

		if (!feedProvider.s3_prefix) {
			missing.push('S3 Prefix');
		}
		if (!installation.feedprefix) {
			missing.push('Feed File Name');
		}

		if (missing.length > 0) {
			return <span className="feed-s3-key-value feed-s3-key-missing">{`Add ${missing.join(' and ')} to build the key`}</span>;
		}

		return <span className="feed-s3-key-value">{`${S3_INGEST_BUCKET}${feedProvider.s3_prefix}${installation.feedprefix}`}</span>;
	}

	purgeStages() {
		const names = ['feed_only_purge_from', 'feed_only_purge_from1', 'feed_only_purge_from2',
			'feed_only_purge_from3', 'feed_only_purge_from4', 'feed_only_purge_from5',
			'feed_only_purge_from6', 'feed_only_purge_from7', 'feed_only_purge_from8'];

		return names.map((name, i) => (
			<div className="col-md-4" key={name}>
				<EditDealershipSettings {...this.props} type={'select-departments'} name={name} label={`Stage ${i + 1}`} value={this.dealerSettingValue(name)} />
			</div>
		));
	}

	render() {
		const { installation } = this.props;
		const feedProvider = this.currentFeedProvider();
		const {
			s3Preset, s3Draft, s3PresetSaving,
		} = this.state;
		const s3Configuration = s3Draft ? { ...feedProvider, ...s3Draft } : feedProvider;

		return (
			<div className="col-md-12 feed-settings">
				<div className="card bg-light space-bottom-1 space-top-1 mx-auto w-75 p-3">

					<section className="feed-group">
						<div className="feed-group-head">
							<h4 className="feed-group-title">Dealer feed</h4>
							<span className="feed-group-note">How this dealership receives inventory</span>
						</div>
						<div className="row">
							<div className="col-md-6">
								<EditInstallation {...this.props} type={'select-provider'} name="provider" label="Feed Provider" value={installation.provider} parentid={installation.id} />
							</div>
							<div className="col-md-6">
								<EditInstallation {...this.props} type={'text'} name="feedprefix" label="Feed File Name (With Ext)" placeholder="iP-22212__INV.csv" value={installation.feedprefix} parentid={installation.id} />
							</div>
							<div className="col-md-6">
								<EditInstallation {...this.props} type={'text'} name="feed_contact" label="Feed Contact" placeholder="Name of the contact at the feed vendor" value={installation.feed_contact} parentid={installation.id} />
							</div>
							<div className="col-md-6">
								<EditInstallation {...this.props} type={'text'} name="feed_email" label="Feed Email" placeholder="feeds@vendor.com" value={installation.feed_email} parentid={installation.id} />
							</div>
						</div>
					</section>

					{feedProvider ? (
						<section className="feed-group">
							<div className="feed-group-head">
								<h4 className="feed-group-title">S3 import</h4>
								<span className="feed-group-note">Shared settings for the selected feed provider</span>
							</div>
							<div className="feed-preset">
								<div className="feed-preset-field">
									<label className="control-label" htmlFor="s3-configuration-preset">Configuration preset</label>
									<select
										id="s3-configuration-preset"
										className="form-control"
										value={s3Preset}
										onChange={this.onS3PresetChange}
										disabled={s3PresetSaving}
									>
										<option value="">Choose a provider preset</option>
										{Object.keys(S3_PROVIDER_PRESETS).map(name => (
											<option key={name} value={name}>{name}</option>
										))}
									</select>
								</div>
								{s3Preset ? (
									<div className="feed-preset-actions">
										<button type="button" className="btn btn-primary" onClick={this.applyS3Preset} disabled={s3PresetSaving}>
											{s3PresetSaving ? 'Applying…' : 'Apply preset'}
										</button>
										<button type="button" className="btn btn-link" onClick={this.cancelS3Preset} disabled={s3PresetSaving}>Cancel</button>
									</div>
								) : null}
							</div>
							<div className="row">
								<div className="col-md-4">
									<EditFeedProvider
										key={`fp_${feedProvider.id}_s3_prefix`}
										type={'text'}
										name="s3_prefix"
										label="S3 Prefix"
										placeholder="provider/"
										value={s3Configuration.s3_prefix || ''}
										parentid={feedProvider.id}
										deferSave={Boolean(s3Preset)}
										onChange={s3Preset ? this.onS3DraftChange : undefined}
									/>
								</div>
								<div className="col-md-4">
									<EditFeedProvider
										key={`fp_${feedProvider.id}_importer_class`}
										type={'text'}
										name="importer_class"
										label="Importer Class"
										placeholder="ProviderImporter"
										value={s3Configuration.importer_class || ''}
										parentid={feedProvider.id}
										deferSave={Boolean(s3Preset)}
										onChange={s3Preset ? this.onS3DraftChange : undefined}
									/>
								</div>
								<div className="col-md-4">
									<EditFeedProvider
										key={`fp_${feedProvider.id}_feed_path_env`}
										type={'text'}
										name="feed_path_env"
										label="Feed Path Env"
										placeholder="PROVIDER_FEED_PATH"
										value={s3Configuration.feed_path_env || ''}
										parentid={feedProvider.id}
										deferSave={Boolean(s3Preset)}
										onChange={s3Preset ? this.onS3DraftChange : undefined}
									/>
								</div>
							</div>
							<div className="feed-s3-key">
								<span className="feed-s3-key-label">Key the scanner matches, exactly and case sensitive</span>
								{this.s3KeyPreview(s3Configuration)}
							</div>
						</section>
					) : null}

					<section className="feed-group">
						<div className="feed-group-head">
							<h4 className="feed-group-title">Other feeds</h4>
							<span className="feed-group-note">Imported by scheduled tasks, not the S3 scanner</span>
						</div>
						<div className="row">
							<div className="col-md-4">
								<EditInstallation {...this.props} type={'text'} name="vendor_feedprefix" label="Vendor Feed Prefix" placeholder="EASTCHESTER" value={installation.vendor_feedprefix} parentid={installation.id} />
							</div>
							<div className="col-md-4">
								<EditInstallation {...this.props} type={'text'} name="photo_feedprefix" label="Photo Feed File Name (With Ext)" placeholder="dealer123_images.csv" value={installation.photo_feedprefix} parentid={installation.id} />
							</div>
							<div className="col-md-4">
								<EditInstallation {...this.props} type={'text'} name="appraisal_feedprefix" label="Appraisal Feed Prefix" placeholder="Not used to match files" value={installation.appraisal_feedprefix} parentid={installation.id} />
							</div>
						</div>
					</section>

					<section className="feed-group">
						<div className="feed-group-head">
							<h4 className="feed-group-title">Purge safety</h4>
							<span className="feed-group-note">What happens to vehicles missing from a feed</span>
						</div>
						<div className="row">
							<div className="col-md-6">
								<EditDealershipSettings {...this.props} type={'switch'} name="feed_override_sold" label="Override Sold Safety" value={this.dealerSettingValue('feed_override_sold')} />
							</div>
							<div className="col-md-6">
								<EditDealershipSettings {...this.props} type={'switch'} name="feed_exclude_new" label="Exclude New" value={this.dealerSettingValue('feed_exclude_new')} />
							</div>
							<div className="col-md-6">
								<EditDealershipSettings {...this.props} type={'switch'} name="feed_safe_purge" label="Turn on Safe Purge" value={this.dealerSettingValue('feed_safe_purge')} />
							</div>
							<div className="col-md-6">
								<EditDealershipSettings {...this.props} type={'switch'} name="feed_shared" label="Feed Shared" value={this.dealerSettingValue('feed_shared')} />
							</div>
							<div className="col-md-6">
								<EditDealershipSettings {...this.props} type={'text'} name="feed_sold_percentage" label="Sold Safety Percentage" value={this.dealerSettingValue('feed_sold_percentage')} />
							</div>
							<div className="col-md-6">
								<EditDealershipSettings {...this.props} type={'text'} name="feed_shared_with" label="Dealers that Share Feed (seperate by comma)" value={this.dealerSettingValue('feed_shared_with')} />
							</div>
						</div>
					</section>

					<section className="feed-group">
						<div className="feed-group-head">
							<h4 className="feed-group-title">Only purge while in these stages</h4>
							<span className="feed-group-note">Leave a slot empty to skip it</span>
						</div>
						<div className="row">
							{this.purgeStages()}
						</div>
					</section>

					<section className="feed-group">
						<div className="feed-group-head">
							<h4 className="feed-group-title">Process a feed file</h4>
						</div>
						{this.isS3Configured(feedProvider) ? (
							<div className="feed-s3-sync">
								<button
									type="button"
									className="btn btn-success"
									onClick={this.runS3Sync}
									disabled={this.state.s3ScanRunning}
								>
									{this.state.s3ScanRunning ? 'Running…' : 'Run S3 Sync'}
								</button>
								<span className="feed-s3-sync-status">{this.feedScanSummary()}</span>
								{this.state.s3ScanError ? (
									<span className="feed-s3-sync-error" role="alert">{this.state.s3ScanError}</span>
								) : null}
							</div>
						) : (
							<DropBoxFeed {...this.props} installation={installation.id} siteid={`${installation.id}_feed`} />
						)}
					</section>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		dealer_settings: state.settings_site.dealer_settings,
		installation: state.settings_dealerships.installation,
		feed_providers: state.settings_feed.feed_providers,
		feed_scan_summary: state.settings_feed.feed_scan_summary,
	};
}

const mappedActions = {
	updateFeedProviders,
	startFeedScan,
	getFeedScanSummary,
};

export default connect(mapStateToProps, mappedActions)(FeedSettings);
